// extracted by mini-css-extract-plugin
module.exports = {"deliveryStatus":"_3tYpt0","text":"_2tcdgZ","brandColor":"Dop8uP","grayColor":"k215Bk","truckIcon":"_12cmU-"};